export default "__VITE_ASSET__DTdcymu6__"